import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import OtpInput from 'react-otp-input';
import { Box, Grid } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getOtp } from 'redux/actions/UserOtp';
import Timer from './Timer';
import BackDrop from 'components/backDrop/BackDrop';
import { companyDetails } from 'utils/companyDetails';

function Otp(props) {
  const navigate = useNavigate();
    const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const userOtp = useSelector((state) => state);
  const isLoader = userOtp?.userOtp?.loading;
  const mobile = localStorage.getItem('mobile');
  const otpSecret = localStorage.getItem('secretToken');
  const redirectUrl = searchParams?.get('redirect');

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();

  const [errorOtp, setErrorOtp] = useState('');
  const [autoFocusOtp, setAutoFocusOtp] = useState(true);

  const resetOtp = () => {
    reset();
    setErrorOtp('');
  };

  const onSubmit = (data) => {
    const mobile = localStorage.getItem('mobile');
    const otpDetails = {
      platform: 'AdminApp',
      mobileOrEmail: mobile,
      otp: data,
      otpSecret: otpSecret,
      countryCode: '+91',
    };
    dispatch(getOtp(otpDetails, navigate, { resetOtp: resetOtp, setAutoFocusOtp: setAutoFocusOtp }));
  };

  // Back button shouldn't clear redirectUrl
  const onBackBtn = () => {
    localStorage.removeItem('mobile');
    localStorage.removeItem('secretToken');
    // keep redirectUrl intact so back->login still knows where to go
    props?.onOtpPage(false);
  };

  // If mobile missing, go back to login
  useEffect(() => {
    const mobileVal = localStorage.getItem('mobile');
    if (!mobileVal) {
      navigate('/login');
    }
  }, [navigate]);

useEffect(() => {
  const otpResponse = userOtp?.userOtp?.userOtp;
  if (otpResponse?.success) {
    if (redirectUrl) {
      navigate(redirectUrl, { replace: true });
    } else {
      navigate("/");
    }
  }
}, [userOtp, navigate, redirectUrl]);


  useEffect(() => {
    if (isLoader) {
      setAutoFocusOtp(false);
    }
  }, [isLoader]);

  const handleOtpChange = (value) => {
    const validateNumber = /^\d+$/.test(value); // Check if value contains only digits
    if (!validateNumber) {
      setErrorOtp('OTP must contain only numbers');
    } else if (value.length === 4 && validateNumber) {
      setErrorOtp('');
      onSubmit(value);
    } else {
      setErrorOtp('OTP must be 4 characters long');
    }
  };

  return (
    <div>
      <Box sm={{ flexGrow: 1 }} className=" mobileRes loginMain">
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }} className="positionAbsolute otpLogoImg">
              <Box className="justifystart">
                <a onClick={() => onBackBtn()} href="/login" className="justifyCenter otpBackButton cursor" rel="login redirect">
                  <ArrowBackIcon className="otpBackIcon" />
                </a>
                <img src={companyDetails?.companyLogo} className="otpLogo" alt="otplogo" />
              </Box>
            </Box>

            <div className="loginInput loginMain mobileBg">
              <Grid container justifyContent="center" alignItems="center" rowSpacing={1}>
                <Grid item sm={8} sx={{ textAlign: 'center' }} className="">
                  <div className="col-12 text-center">
                    <h1 className="fontBold font36 colorBlue m0">
                      Enter your <span className="colorYellow">OTP</span>
                    </h1>
                    <p className="colorGrey font16 fontNormal m0">An authentication {companyDetails?.companyName} code has been sent to</p>
                    <p className="colorGrey font16 fontMedium marginBottom35">{mobile}</p>
                  </div>
                </Grid>
                <Grid item sm={8}>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container justifyContent="center" alignItems="center" spacing={1}>
                      <Grid item sm={8} className="otpInput">
                        <Controller
                          name="otp"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: 'OTP is required',
                            minLength: { value: 4, message: 'OTP must be 4 characters long' },
                          }}
                          render={({ field }) => (
                            <OtpInput
                              containerStyle="otp"
                              inputStyle={errors.otp ? 'otpStyleError' : 'otpStyle'}
                              value={field.value}
                              onChange={(value) => {
                                field.onChange(value);
                                handleOtpChange(value);
                              }}
                              numInputs={4}
                              inputType="tel"
                              renderInput={(props) => <input {...props} disabled={isLoader} />}
                              shouldAutoFocus={autoFocusOtp}
                            />
                          )}
                        />
                        {errorOtp && (
                          <p className="errorOtp">
                            <span>
                              <ErrorIcon />
                            </span>
                            {errorOtp}
                          </p>
                        )}
                      </Grid>
                      <Grid container item sm={8} justifyContent="center" className="otpInput">
                        <Grid item>
                          <div>
                            <Timer onResend={resetOtp} setAutoFocusOtp={setAutoFocusOtp} />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </div>
          </Grid>

          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <div className="loginBgImg" />
          </Grid>
        </Grid>
      </Box>
      <BackDrop open={isLoader} />
    </div>
  );
}

export default Otp;
